"use client";

import Link from "next/link";
import "@/styles/shared/_not-found.scss";

export interface NotFoundProps {
  /** Tiêu đề trang không tồn tại */
  title?: string;
  /** Mô tả chi tiết */
  description?: string;
  /** Nút quay lại - label và href */
  backButton?: {
    label: string;
    href: string;
  };
  /** Nút về trang chủ - label và href */
  homeButton?: {
    label: string;
    href: string;
  };
  /** CSS class modifier (vd: not-found--dao-tao) */
  modifier?: string;
  /** Nội dung tùy chỉnh thay vì mặc định */
  children?: React.ReactNode;
}

export function NotFound({
  title = "Bài viết không tồn tại",
  description = "Liên kết có thể đã thay đổi, bị xóa hoặc bài viết chưa được xuất bản.",
  backButton = { label: "Quay lại", href: "/" },
  homeButton = { label: "Về trang chủ", href: "/" },
  modifier = "",
  children,
}: NotFoundProps) {
  return (
    <section className="not-found-header">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className={`not-found-empty ${modifier}`.trim()}>
              {children ? (
                children
              ) : (
                <>
                  <h1 className="not-found-empty__title">{title}</h1>
                  <p className="not-found-empty__description">{description}</p>

                  <div className="not-found-empty__actions">
                    {backButton && (
                      <Link
                        href={backButton.href}
                        className="not-found-empty__btn not-found-empty__btn--primary"
                      >
                        {backButton.label}
                      </Link>
                    )}
                    {homeButton && (
                      <Link
                        href={homeButton.href}
                        className="not-found-empty__btn not-found-empty__btn--ghost"
                      >
                        {homeButton.label}
                      </Link>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default NotFound;

